<template>
  <div class="llk">

    <!-- traka -->
    <div class="llk-traka">
      <div>
        <div class="llk-naslov">
          <template v-if="kartica && kartica.llaID">{{ kartica.naziv }}</template>
          <template v-else>Povijesna kartica osnovnog sredstva</template>
        </div>
        <div class="llk-pod" v-if="kartica && kartica.llaID">
          Šifra int. {{ kartica.llaID }} · AOP oznaka {{ kartica.llaCode }}
          · Povijesna kartica osnovnog sredstva · {{ kartica.prvaGodina }} – {{ kartica.tekucaGodina }}
          <template v-if="kartica.stopaTekuca !== null && kartica.stopaTekuca !== undefined"> · stopa {{ fmt(kartica.stopaTekuca) }} %</template>
        </div>
        <div class="llk-pod" v-if="podaciSredstva">
          <template v-if="podaciSredstva.dokumentNabave">Dokument nabave: <b>{{ podaciSredstva.dokumentNabave }}</b><template v-if="podaciSredstva.datumDokumenta"> od {{ podaciSredstva.datumDokumenta }}</template></template>
          <template v-if="podaciSredstva.pocetakAmortizacije"> · Početak amortizacije: <b>{{ podaciSredstva.pocetakAmortizacije }}</b></template>
          <template v-if="podaciSredstva.vijekMjeseci !== null && podaciSredstva.vijekMjeseci !== undefined"> · Vijek trajanja: <b>{{ podaciSredstva.vijekMjeseci }} mj.</b></template>
          <template v-if="podaciSredstva.konto"> · Konto sredstva: <b>{{ podaciSredstva.konto }}</b></template>
          <template v-if="podaciSredstva.iskljuceno"> · <b>Isključeno</b></template>
          <template v-if="podaciSredstva.datumProdaje"> · Datum prodaje: <b>{{ podaciSredstva.datumProdaje }}</b></template>
        </div>
        <div class="llk-pod" v-for="(n, i) in (kartica && kartica.napomene) || []" :key="'kn' + i">{{ n }}</div>
      </div>
      <div class="llk-razmak"></div>
      <button type="button" class="llk-b llk-b-bijeli" title="Natrag na popis osnovnih sredstava" @click="natrag">&larr; Natrag na popis</button>
      <button type="button" class="llk-b llk-b-bijeli" :disabled="!imaKarticu" :title="sveOtvoreno ? 'Zatvori knjiženje u svim godinama' : 'Otvori knjiženje u svim godinama'" @click="prebaciSve">{{ sveOtvoreno ? 'Sažeto' : 'Detaljno' }}</button>
      <button type="button" class="llk-b llk-b-bijeli" :disabled="!imaKarticu" @click="ispisi">Ispis / PDF</button>
      <button type="button" class="llk-b llk-b-bijeli" :disabled="!imaKarticu" @click="izvezi">Excel</button>
    </div>

    <!-- odabir sredstva -->
    <div class="llk-odabir">
      <v-row dense>
        <v-col cols="12" md="3">
          <v-select
            v-model="aopFilter"
            :items="aopStavke"
            item-value="llaCode"
            label="AOP oznaka"
            prepend-inner-icon="mdi-filter-variant"
            dense
            outlined
            hide-details
            clearable
            no-data-text="Nema AOP oznaka"
          >
            <template v-slot:selection="{ item }">{{ item.llaCode }} ({{ item.sredstava }})</template>
            <template v-slot:item="{ item }">{{ item.llaCode }} <small class="llk-mala">&nbsp;· {{ item.sredstava }} {{ item.sredstava === 1 ? 'sredstvo' : 'sredstava' }}</small></template>
          </v-select>
        </v-col>
        <v-col cols="12" md="9">
          <v-autocomplete
            v-model="odabrana"
            :items="stavkePopisa"
            :item-text="tekstStavke"
            item-value="llaID"
            :filter="() => true"
            :search-input.sync="upitPretrage"
            :loading="ucitavaPopis"
            label="Sredstvo (šifra int., AOP oznaka ili naziv)"
            placeholder="Npr. bmw, 346, INV-B ili više riječi: bmw inv-b"
            prepend-inner-icon="mdi-magnify"
            dense
            outlined
            hide-details
            clearable
            no-data-text="Nema takvog sredstva"
            :menu-props="{contentClass: 'llk-izbornik', maxHeight: 420}"
            @change="odabirPromijenjen"
          >
            <template v-slot:item="{ item }">
              <div class="llk-stavka">
                <b class="llk-naziv">{{ item.naziv }}</b>
                <small>Šifra int. {{ item.llaID }} · AOP {{ item.llaCode }}
                  · {{ item.odGodine }}–{{ item.doGodine }}
                  · nabavna {{ fmt(item.nabavna) }}, neto {{ fmt(item.netoKraj) }}
                  <template v-if="item.uTekucoj === false"> · nije u tekućoj godini</template></small>
              </div>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <div v-if="aopFilter" class="llk-aop-trak">
        AOP oznaka <b>{{ aopFilter }}</b>: {{ stavkePopisa.length }} {{ stavkePopisa.length === 1 ? 'sredstvo' : 'sredstava' }}
        <button type="button" class="llk-b llk-b-obrub" @click="otvoriZbirno">{{ zbirno ? 'Sakrij zbirno po AOP oznaci' : 'Zbirno po AOP oznaci' }}</button>
      </div>
    </div>

    <!-- zbirno po AOP oznaci -->
    <div v-if="aopFilter && zbirno" class="llk-kartica">
      <div class="llk-glava">
        <h2>Zbirno po AOP oznaci {{ aopFilter }}</h2>
        <small>zbroj svih sredstava koja u toj godini nose ovu oznaku; klik na godinu otvara sredstva i temeljnice</small>
        <span class="llk-razmak"></span>
        <button type="button" class="llk-b llk-b-obrub" @click="prebaciSveAop">{{ sveOtvorenoAop ? 'Sažeto' : 'Detaljno' }}</button>
      </div>
      <div class="llk-tijelo">
        <table class="llk-tab">
          <thead>
            <tr>
              <th class="l">Godina</th><th>Sredstava</th><th>Nabavna vrijednost</th><th>Ispravak početak</th>
              <th>Amortizacija godine</th><th>Ispravak kraj</th><th>Neto kraj godine</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="g in zbirno.godine">
              <tr :key="'z' + g.godina" class="llk-god llk-klik" @click="prebaciAop(g.godina)">
                <td class="l"><span class="llk-strelica">{{ otvoreneAop.indexOf(g.godina) !== -1 ? '▾' : '▸' }}</span> {{ g.godina }}</td>
                <td>{{ g.sredstava }}</td><td>{{ fmt(g.nabavna) }}</td><td>{{ fmt(g.ispravakPocetak) }}</td>
                <td>{{ fmt(g.amortizacija) }}</td><td>{{ fmt(g.ispravakKraj) }}</td><td>{{ fmt(g.netoKraj) }}</td>
              </tr>
              <tr v-if="otvoreneAop.indexOf(g.godina) !== -1" :key="'zd' + g.godina" class="llk-detalj">
                <td colspan="7" class="l">
                  <table class="llk-mini">
                    <thead>
                      <tr>
                        <th class="l">Šifra int.</th><th class="l">Naziv</th><th>Nabavna</th><th>Ispravak početak</th><th>Amortizacija</th>
                        <th>Ispravak kraj</th><th>Neto kraj</th><th class="l">Temeljnica</th><th>Po temeljnici duguje</th><th>Po temeljnici potražuje</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="x in g.popis" :key="'zs' + g.godina + '_' + x.llaID">
                        <td class="l">{{ x.llaID }}</td><td class="l">{{ x.naziv }}</td><td>{{ fmt(x.nabavna) }}</td><td>{{ fmt(x.ispravakPocetak) }}</td>
                        <td>{{ fmt(x.amortizacija) }}</td><td>{{ fmt(x.ispravakKraj) }}</td><td>{{ fmt(x.netoKraj) }}</td>
                        <td class="l">
                          <template v-if="x.temeljnice && x.temeljnice.length"><span v-for="t in x.temeljnice" :key="t.id" class="llk-tem">OS {{ t.bookID }} · {{ t.datum }}</span></template>
                          <template v-else>nema temeljnice</template>
                          <span v-if="x.nesigurnaVeza" class="llk-crv" title="Naziv dijeli više sredstava u godini"> ⚠ veza po nazivu</span>
                        </td>
                        <td>{{ x.temeljniceZbroj ? fmt(x.temeljniceZbroj.duguje) : '' }}</td><td>{{ x.temeljniceZbroj ? fmt(x.temeljniceZbroj.potrazuje) : '' }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr><td class="l" colspan="7">Zbroj temeljnica godine</td><td></td><td>{{ g.temeljniceZbroj ? fmt(g.temeljniceZbroj.duguje) : '' }}</td><td>{{ g.temeljniceZbroj ? fmt(g.temeljniceZbroj.potrazuje) : '' }}</td></tr>
                    </tfoot>
                  </table>
                </td>
              </tr>
            </template>
          </tbody>
          <tfoot>
            <tr><td class="l" colspan="4">Zbroj amortizacije kroz sve godine</td><td>{{ fmt(zbirno.ukupnoAmortizacija) }}</td><td colspan="2"></td></tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div v-if="greska" class="llk-greska" role="alert">{{ greska }}</div>
    <v-progress-linear v-if="ucitava" indeterminate color="primary" class="mb-2"></v-progress-linear>

    <div v-if="!imaKarticu && !ucitava && !greska" class="llk-prazno">
      Odaberi sredstvo na popisu iznad ili na ekranu Osnovna sredstva. Pretraga traži po šifri int., AOP oznaci i nazivu.
    </div>

    <template v-if="imaKarticu">

      <!-- brojke -->
      <div class="llk-brojke">
        <div><span>Nabavna vrijednost</span><b>{{ fmt(sazetak.nabavna) }}</b></div>
        <div><span>Ukupni ispravak vrijednosti</span><b>{{ fmt(sazetak.ispravakKraj) }}</b></div>
        <div class="llk-ok"><span>Neto vrijednost {{ sazetak.godina }}</span><b>{{ fmt(sazetak.netoKraj) }}</b></div>
        <div><span>Amortizacija kroz godine</span><b>{{ fmt(kartica.ukupnoAmortizacija) }}</b></div>
        <div v-if="!sazetak.uEvidencijiTekuce" class="llk-lose"><span>Status</span><b>nema zapisa u {{ kartica.tekucaGodina }}</b></div>
      </div>

      <div v-if="kartica.upozorenja.length" class="llk-upoz" role="alert">
        <b>Odstupanja u podacima ({{ kartica.upozorenja.length }})</b> — podaci nisu ispravljani.
        <ul>
          <li v-for="(u, i) in kartica.upozorenja" :key="i">{{ u }}</li>
        </ul>
      </div>

      <!-- tablica po godinama -->
      <div class="llk-kartica">
        <div class="llk-glava">
          <h2>Po godinama</h2>
        </div>
        <div class="llk-tijelo">
          <table class="llk-tab">
            <thead>
              <tr>
                <th class="l">Godina</th>
                <th>Nabavna vrijednost</th>
                <th>Ispravak početak</th>
                <th>Amortizacija godine</th>
                <th>Ispravak kraj</th>
                <th>Neto kraj godine</th>
                <th>Stopa %</th>
                <th class="l">Napomena</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="g in kartica.godine">
                <tr :key="'g' + g.godina" class="llk-god"
                    :class="{'llk-tekuca': g.tekuca, 'llk-nema': g.nemaZapisa, 'llk-klik': !!g.knjizenje}"
                    @click="prebaci(g)">
                  <td class="l">
                    <span class="llk-strelica">{{ g.knjizenje ? (otvorene.indexOf(g.godina) !== -1 ? '▾' : '▸') : '' }}</span>
                    {{ g.godina }}
                    <span v-if="g.tekuca" class="llk-oznaka">tekuća</span>
                  </td>
                  <template v-if="!g.nemaZapisa">
                    <td>{{ fmt(g.nabavna) }}</td>
                    <td>{{ fmt(g.ispravakPocetak) }}</td>
                    <td>{{ fmt(g.amortizacija) }}</td>
                    <td>{{ fmt(g.ispravakKraj) }}</td>
                    <td>{{ fmt(g.netoKraj) }}</td>
                    <td>{{ stopa(g) }}</td>
                  </template>
                  <template v-else>
                    <td></td><td></td><td></td><td></td><td></td><td></td>
                  </template>
                  <td class="l llk-nap">
                    <div v-for="(n, i) in g.napomene" :key="'n' + i">{{ n }}</div>
                    <div v-for="(u, i) in g.upozorenja" :key="'u' + i" class="llk-crv">⚠ {{ u }}</div>
                  </td>
                </tr>
                <tr v-if="g.knjizenje && otvorene.indexOf(g.godina) !== -1" :key="'d' + g.godina" class="llk-detalj">
                  <td colspan="8" class="l">
                    <div class="llk-dnaslov">Knjiženje u godini {{ g.godina }} – temeljnice</div>
                    <table class="llk-mini">
                      <thead>
                        <tr><th class="l">Temeljnica</th><th class="l">Konto</th><th class="l">Naziv konta</th><th>Duguje</th><th>Potražuje</th><th class="l">Opis</th></tr>
                      </thead>
                      <tbody>
                        <tr v-if="!g.knjizenje.temeljnice || !g.knjizenje.temeljnice.length">
                          <td colspan="6" class="l llk-sivo">nema temeljnice u ovoj godini</td>
                        </tr>
                        <template v-for="t in g.knjizenje.temeljnice || []">
                          <tr v-for="(x, i) in t.stavke" :key="'t' + g.godina + '_' + t.id + '_' + x.id">
                            <td class="l"><template v-if="i === 0"><b>OS {{ t.bookID }}</b> · {{ t.datum }} <small class="llk-sivo">(id {{ t.id }})</small></template></td>
                            <td class="l">{{ x.konto }}</td><td class="l">{{ x.nazivKonta }}</td>
                            <td>{{ fmt(x.duguje) }}</td><td>{{ fmt(x.potrazuje) }}</td><td class="l">{{ x.opis }}</td>
                          </tr>
                        </template>
                      </tbody>
                      <tfoot v-if="g.knjizenje.temeljnice && g.knjizenje.temeljnice.length">
                        <tr>
                          <td class="l" colspan="3">Zbroj temeljnica <small class="llk-sivo">(amortizacija godine {{ fmt(g.amortizacija) }})</small></td>
                          <td>{{ fmt(g.knjizenje.temeljniceZbroj.duguje) }}</td><td>{{ fmt(g.knjizenje.temeljniceZbroj.potrazuje) }}</td><td></td>
                        </tr>
                      </tfoot>
                    </table>
                    <div v-if="g.knjizenje.nesigurnaVeza" class="llk-crv llk-mali">⚠ Veza stavki sa sredstvom je po nazivu, a naziv dijeli više sredstava u ovoj godini.</div>

                    <div v-if="g.knjizenje.stavke.length" class="llk-dnaslov llk-dnaslov-mali">Zapis sredstva u godini (izveden iz evidencije)</div>
                    <table v-if="g.knjizenje.stavke.length" class="llk-mini">
                      <thead>
                        <tr><th class="l">Stavka</th><th class="l">Konto</th><th class="l">Naziv konta</th><th>Duguje</th><th>Potražuje</th><th class="l">Napomena</th></tr>
                      </thead>
                      <tbody>
                        <tr v-for="(x, i) in g.knjizenje.stavke" :key="'s' + g.godina + '_' + i">
                          <td class="l">{{ x.stavka }}</td><td class="l">{{ x.konto }}</td><td class="l">{{ x.nazivKonta }}</td>
                          <td>{{ x.duguje === null ? '' : fmt(x.duguje) }}</td><td>{{ x.potrazuje === null ? '' : fmt(x.potrazuje) }}</td><td class="l">{{ x.napomena }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </template>
            </tbody>
            <tfoot>
              <tr>
                <td class="l" colspan="3">Zbroj amortizacije kroz sve godine</td>
                <td>{{ fmt(kartica.ukupnoAmortizacija) }}</td>
                <td colspan="4"></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div class="llk-nota">
        Ispravak na početku je ukupni ispravak vrijednosti na početku godine; na kraju je početni uvećan za amortizaciju godine.
        Kad se nabavna vrijednost smanji (rashod/prodaja), ispravak se razmjerno preračuna pa ne slijedi iz kraja prethodne godine.
        Neto kraj godine je zapis iz knjige; mora biti nabavna − ispravak kraj.
      </div>
    </template>
  </div>
</template>

<script>
import MainLedgerLLAService from '@/services/MainLedgerLLAService'
import moneyFormat from '@/snippets/moneyFormat'
import { printLlaKarticaPdf } from './llaKarticaPdf'
import { exportLlaKarticaXlsx } from './llaKarticaXlsx'

// Pretraga bez obzira na dijakritike (č, ć, š, ž, đ) i velika slova.
const bezDijakritika = (t) => String(t || '')
  .toLowerCase()
  .replace(/đ/g, 'd')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')

export default {
  name: 'MainLedgerLLAKartica',
  data () {
    return {
      popis: [],
      aop: [],
      aopFilter: null,
      upitPretrage: '',
      zbirno: null,
      otvorene: [],
      otvoreneAop: [],
      ucitavaPopis: false,
      odabrana: null,
      kartica: null,
      ucitava: false,
      greska: null
    }
  },
  computed: {
    // Podaci sredstva koji se ne mijenjaju po godinama (dokument nabave, početak amortizacije,
    // vijek, konto sredstva) prikazuju se jednom u zaglavlju, iz zadnje godine koja ih ima.
    podaciSredstva () {
      const k = this.kartica
      const godine = k && Array.isArray(k.godine) ? k.godine : []
      for (let i = godine.length - 1; i >= 0; i--) {
        const z = godine[i] && godine[i].knjizenje
        if (z && (z.dokumentNabave || z.pocetakAmortizacije || (z.kontoSredstva && z.kontoSredstva.konto))) {
          return {
            dokumentNabave: z.dokumentNabave,
            datumDokumenta: z.datumDokumenta,
            pocetakAmortizacije: z.pocetakAmortizacije,
            vijekMjeseci: z.vijekMjeseci,
            konto: z.kontoSredstva && z.kontoSredstva.konto,
            iskljuceno: z.iskljuceno,
            datumProdaje: z.datumProdaje
          }
        }
      }
      return null
    },
    imaKarticu () {
      return !!(this.kartica && this.kartica.godine && this.kartica.godine.length)
    },
    sazetak () {
      return this.kartica && this.kartica.sazetak ? this.kartica.sazetak : {}
    },
    godineSKnjizenjem () {
      return this.kartica && this.kartica.godine ? this.kartica.godine.filter(g => g.knjizenje).map(g => g.godina) : []
    },
    sveOtvoreno () {
      return this.godineSKnjizenjem.length > 0 && this.godineSKnjizenjem.every(g => this.otvorene.indexOf(g) !== -1)
    },
    sveOtvorenoAop () {
      const sve = this.zbirno && this.zbirno.godine ? this.zbirno.godine.map(g => g.godina) : []
      return sve.length > 0 && sve.every(g => this.otvoreneAop.indexOf(g) !== -1)
    },
    aopStavke () {
      return this.aop
    },
    // popis sredstava (filtriran po AOP oznaci), sa zapisima koji tocno odgovaraju upitu na vrhu
    stavkePopisa () {
      let stavke = this.popis
      if (this.aopFilter) { stavke = stavke.filter(s => s.llaCode === String(this.aopFilter)) }
      const q = bezDijakritika(this.upitPretrage).trim()
      // upit koji je tekst odabranog sredstva ne filtrira (inace bi popis nakon odabira ostao sam)
      if (!q || (this.odabranaStavka && q === bezDijakritika(this.tekstStavke(this.odabranaStavka)).trim())) { return stavke }
      const rijeci = q.split(/\s+/)
      const nadjeno = stavke.filter(s => {
        const h = bezDijakritika(s.llaID + ' ' + s.llaCode + ' ' + s.naziv)
        return rijeci.every(r => h.indexOf(r) > -1)
      })
      const tocno = (s) => String(s.llaID) === q || bezDijakritika(s.llaCode) === q ? 0 : 1
      return nadjeno.map((s, i) => ({ s, i })).sort((a, b) => tocno(a.s) - tocno(b.s) || a.i - b.i).map(x => x.s)
    },
    odabranaStavka () {
      return this.popis.filter(s => s.llaID === this.odabrana)[0] || null
    }
  },
  watch: {
    '$route.query' () {
      this.sinkronizirajRutu()
    },
    aopFilter () {
      this.zbirno = null
      this.otvoreneAop = []
    }
  },
  async created () {
    await this.ucitajPopis()
    await this.sinkronizirajRutu()
  },
  methods: {
    fmt (v) {
      return moneyFormat(v)
    },
    stopa (g) {
      if (g.stopa !== null && g.stopa !== undefined) { return this.fmt(g.stopa) }
      return this.fmt(g.stopaMin) + '–' + this.fmt(g.stopaMax)
    },
    upit () {
      return {
        CompanyId: this.$store.state.companyid ? this.$store.state.companyid : 1,
        BusinessYear: this.$store.state.businessYear ? this.$store.state.businessYear : null
      }
    },
    prebaci (g) {
      if (!g.knjizenje) { return }
      const i = this.otvorene.indexOf(g.godina)
      if (i === -1) { this.otvorene.push(g.godina) } else { this.otvorene.splice(i, 1) }
    },
    prebaciSve () {
      this.otvorene = this.sveOtvoreno ? [] : this.godineSKnjizenjem.slice()
    },
    prebaciAop (godina) {
      const i = this.otvoreneAop.indexOf(godina)
      if (i === -1) { this.otvoreneAop.push(godina) } else { this.otvoreneAop.splice(i, 1) }
    },
    prebaciSveAop () {
      this.otvoreneAop = this.sveOtvorenoAop ? [] : this.zbirno.godine.map(g => g.godina)
    },
    tekstStavke (s) {
      return s.naziv + ' · šifra int. ' + s.llaID + ' · AOP ' + s.llaCode
    },
    async ucitajPopis () {
      try {
        this.ucitavaPopis = true
        const { data } = await MainLedgerLLAService.karticaPopis(this.upit())
        this.popis = data && data.sredstva ? data.sredstva : []
        this.aop = data && data.aop ? data.aop : []
      } catch (err) {
        this.greska = 'Popis sredstava nije dohvaćen: ' + (err.message || err)
      } finally {
        this.ucitavaPopis = false
      }
    },
    // ?llaID= otvara karticu tog sredstva; ?llaCode= (stari poziv) postavlja filtar AOP oznake
    // i otvara karticu samo ako ta oznaka ima jedno sredstvo, inace korisnik bira sredstvo.
    async sinkronizirajRutu () {
      const q = this.$route.query
      if (q.llaID) {
        const id = parseInt(q.llaID, 10)
        if (id !== this.odabrana) { this.odabrana = id }
        await this.ucitajKarticu(id)
      } else if (q.llaCode) {
        this.aopFilter = String(q.llaCode)
        this.odabrana = null
        this.kartica = null
        const sred = this.popis.filter(s => s.llaCode === String(q.llaCode))
        if (sred.length === 1) {
          this.$router.replace({ name: 'mainledgerLLAKartica', query: { llaID: String(sred[0].llaID) } }).catch(() => {})
        }
      } else {
        this.odabrana = null
        this.kartica = null
      }
    },
    async ucitajKarticu (llaID) {
      if (!llaID) {
        this.kartica = null
        return
      }
      try {
        this.ucitava = true
        this.greska = null
        const q = Object.assign(this.upit(), { llaID })
        const { data } = await MainLedgerLLAService.kartica(q)
        this.kartica = data && data.kartica ? data.kartica : null
        this.otvorene = []
        if (this.kartica && !this.kartica.godine.length) {
          this.greska = 'Sredstvo sa šifrom int. ' + llaID + ' nema zapisa.'
        }
      } catch (err) {
        this.kartica = null
        this.greska = 'Kartica nije dohvaćena: ' + (err.message || err)
      } finally {
        this.ucitava = false
      }
    },
    odabirPromijenjen (llaID) {
      if (!llaID) {
        this.kartica = null
        this.$router.replace({ name: 'mainledgerLLAKartica', query: {} }).catch(() => {})
        return
      }
      this.$router.replace({ name: 'mainledgerLLAKartica', query: { llaID: String(llaID) } }).catch(() => {})
    },
    async otvoriZbirno () {
      if (this.zbirno) { this.zbirno = null; return }
      try {
        const { data } = await MainLedgerLLAService.karticaAop(Object.assign(this.upit(), { llaCode: this.aopFilter }))
        this.zbirno = data && data.zbirno ? data.zbirno : null
        this.otvoreneAop = []
      } catch (err) {
        this.greska = 'Zbirni prikaz nije dohvaćen: ' + (err.message || err)
      }
    },
    ctx () {
      return {
        kartica: this.kartica,
        otvorene: this.otvorene.slice(),
        company: this.$store.state.companyActiv ? this.$store.state.companyActiv : {}
      }
    },
    ispisi () {
      printLlaKarticaPdf(this.ctx())
    },
    izvezi () {
      exportLlaKarticaXlsx(this.ctx())
    },
    natrag () {
      this.$router.push({ name: 'mainledgerLLA' })
    }
  }
}
</script>

<style scoped>
.llk { --plava: #1976d2; --plava-tamna: #1565c0; --plava-svijetla: #eef4fb; --crta: rgba(0,0,0,.12); --sivo: rgba(0,0,0,.6);
  --zelena: #2e7d32; --crvena: #c62828; --zuta-sv: #fff4e0; --zuta: #b26a00;
  max-width: 1200px; margin: 0 auto; padding: 4px 0 70px; font-size: 15px; }
.llk-razmak { flex: 1; }
.llk-traka { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; background: var(--plava); color: #fff; border-radius: 4px; padding: 10px 14px; margin-bottom: 10px; }
.llk-naslov { font-size: 20px; font-weight: 700; line-height: 1.2; }
.llk-pod { font-size: 13px; opacity: .9; margin-top: 2px; }
.llk-b { font-family: inherit; font-size: 14px; font-weight: 500; border-radius: 4px; padding: 7px 14px; cursor: pointer; border: 1px solid transparent; }
.llk-b-bijeli { background: #fff; color: var(--plava); }
.llk-b-bijeli[disabled] { opacity: .55; cursor: not-allowed; }
.llk-b-obrub { background: #fff; color: var(--plava); border-color: var(--plava); }
.llk-odabir { background: #fff; border: 1px solid var(--crta); border-radius: 4px; padding: 10px 14px; margin-bottom: 10px; }
.llk-stavka small, .llk-mala { color: var(--sivo); }
.llk-aop-trak { margin-top: 8px; display: flex; align-items: center; gap: 12px; font-size: 14px; }
.llk-greska { margin: 8px 0; padding: 8px 12px; border: 1px solid #e0b4a8; background: #fbeeea; color: #8c2f1e; }
.llk-prazno { padding: 24px; text-align: center; color: var(--sivo); }

.llk-brojke { display: flex; flex-wrap: wrap; gap: 14px 26px; background: #fff; border: 1px solid var(--crta); border-radius: 4px; padding: 10px 16px; margin-bottom: 10px; }
.llk-brojke span { display: block; font-size: 12px; color: var(--sivo); line-height: 1.2; }
.llk-brojke b { font-size: 19px; font-variant-numeric: tabular-nums; }
.llk-brojke .llk-ok b { color: var(--zelena); }
.llk-brojke .llk-lose b { color: var(--crvena); }

.llk-upoz { margin: 0 0 10px; padding: 8px 12px; background: var(--zuta-sv); border: 1px solid #e8cf9b; color: #6b4300; font-size: 14px; }
.llk-upoz ul { margin: 4px 0 0 18px; padding: 0; }

.llk-kartica { background: #fff; border: 1px solid var(--crta); border-radius: 4px; margin-bottom: 10px; overflow: hidden; }
.llk-glava { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; background: var(--plava-svijetla); border-bottom: 2px solid var(--plava); padding: 8px 14px; }
.llk-glava h2 { margin: 0; font-size: 16px; color: var(--plava-tamna); font-weight: 700; }
.llk-glava small { color: var(--sivo); }
.llk-tijelo { overflow-x: auto; }

.llk-tab { width: 100%; border-collapse: collapse; font-size: 14px; }
.llk-tab th { text-align: right; font-weight: 600; font-size: 12px; color: var(--sivo); padding: 8px 10px; border-bottom: 1px solid var(--crta); white-space: nowrap; }
.llk-tab td { text-align: right; padding: 7px 10px; border-bottom: 1px solid var(--crta); font-variant-numeric: tabular-nums; vertical-align: top; }
.llk-tab th.l, .llk-tab td.l { text-align: left; }
.llk-god td { font-weight: 600; }
.llk-tekuca td { background: var(--plava-svijetla); border-bottom: 1px solid var(--plava); }
.llk-nema td { color: var(--sivo); font-weight: 400; font-style: italic; }
.llk-oznaka { display: inline-block; margin-left: 6px; padding: 0 6px; font-size: 11px; font-weight: 600; color: #fff; background: var(--plava); border-radius: 8px; vertical-align: middle; }
.llk-nap { font-weight: 400 !important; font-size: 12.5px; color: var(--sivo); min-width: 220px; }
.llk-crv { color: var(--crvena); }
.llk-tab tfoot td { font-weight: 700; border-top: 2px solid var(--plava); border-bottom: 0; }
.llk-klik { cursor: pointer; }
.llk-klik:hover td { background: #f6f9fd; }
.llk-strelica { display: inline-block; width: 12px; color: var(--plava); }
.llk-detalj > td { background: #fafcff; padding: 8px 14px 10px 28px; border-bottom: 1px solid var(--plava); }
.llk-dnaslov { font-size: 13px; font-weight: 700; color: var(--plava-tamna); margin: 0 0 4px; text-align: left; }
.llk-dnaslov-mali { margin-top: 10px; font-weight: 600; color: var(--sivo); }
.llk-mini { width: 100%; border-collapse: collapse; font-size: 13px; }
.llk-mini th { text-align: right; font-weight: 600; font-size: 11.5px; color: var(--sivo); padding: 4px 8px; border-bottom: 1px solid var(--crta); white-space: nowrap; }
.llk-mini td { text-align: right; padding: 3px 8px; border-bottom: 1px solid var(--crta); font-weight: 400; font-variant-numeric: tabular-nums; vertical-align: top; }
.llk-mini th.l, .llk-mini td.l { text-align: left; }
.llk-mini tfoot td { font-weight: 700; border-top: 1px solid var(--plava); border-bottom: 0; }
.llk-sivo { color: var(--sivo); font-weight: 400; }
.llk-mali { font-size: 12.5px; margin-top: 4px; text-align: left; }
.llk-tem { display: inline-block; margin-right: 8px; font-weight: 600; }
.llk-podaci { display: flex; flex-wrap: wrap; gap: 2px 18px; margin-top: 10px; font-size: 12.5px; color: var(--sivo); text-align: left; }
.llk-podaci b { color: rgba(0,0,0,.87); font-weight: 600; }
.llk-nota { font-size: 12px; color: var(--sivo); margin: 4px 2px 0; }
</style>

<!-- Izbornik se crta izvan komponente (detached), pa scoped stil do njega ne dolazi. -->
<style>
.llk-izbornik .v-list-item { min-height: 30px; padding: 2px 12px; }
.llk-izbornik .v-list-item__content { padding: 2px 0; }
.llk-izbornik .llk-stavka { line-height: 1.3; }
.llk-izbornik .llk-naziv { font-weight: 700; color: rgba(0,0,0,.87); margin-right: 6px; }
.llk-izbornik .llk-stavka small { color: rgba(0,0,0,.6); font-size: 12px; }
</style>
